import type { RouteRecordRaw } from "vue-router";
import { routes as featureRoutes } from "@/admin/pages/features/[name]/routes";

/*
 * Top-level, not nested. These were children of a `/maintenance` route whose
 * component was nothing but a `<router-view />` - no shared layout and no tabs -
 * so the nesting only ever prefixed the URLs. The nav groups them now, and
 * grouping is presentation, so the paths say what the page is instead.
 */
export const routes: RouteRecordRaw[] = [
  {
    path: "/imports/",
    name: "imports",
    component: () => import("@/admin/pages/maintenance/imports.vue"),
    meta: {
      mobileBack: true,
      title: "admin.maintenance.imports",
      icon: "fa-duotone fa-cloud-arrow-down",
      needsAuthentication: true,
      access: ["imports"],
    },
  },
  {
    path: "/imports/:id",
    name: "import",
    component: () => import("@/admin/pages/maintenance/imports/[id].vue"),
    meta: {
      title: "admin.maintenance.importDetail",
      needsAuthentication: true,
      access: ["imports"],
      nav: "hidden",
      activeRoute: "imports",
    },
  },
  {
    // Behind `imports` rather than a privilege of its own: the page reads what
    // an import wrote, and nobody who may not see the ledger has a use for a
    // diff of two of its results.
    path: "/build-compare/",
    name: "build-compare",
    component: () => import("@/admin/pages/maintenance/build-compare.vue"),
    meta: {
      title: "admin.maintenance.buildCompare",
      icon: "fa-duotone fa-code-compare",
      needsAuthentication: true,
      access: ["imports"],
    },
  },
  {
    path: "/features/",
    name: "admin-features",
    component: () => import("@/admin/pages/maintenance/features.vue"),
    meta: {
      title: "admin.maintenance.features",
      icon: "fa-duotone fa-circle-star",
      needsAuthentication: true,
      access: ["features"],
    },
  },
  {
    path: "/features/:name/",
    component: () => import("@/admin/pages/features/[name].vue"),
    children: featureRoutes,
    redirect: { name: "admin-feature" },
    meta: {
      title: "admin.features.show",
      needsAuthentication: true,
      access: ["features"],
      nav: "hidden",
      activeRoute: "admin-features",
    },
  },
  {
    path: "/jobs/",
    name: "workers",
    component: () => import("@/admin/pages/maintenance/workers.vue"),
    meta: {
      title: "admin.maintenance.workers",
      icon: "fa-duotone fa-list-timeline",
      needsAuthentication: true,
      access: ["workers"],
    },
  },
  {
    path: "/database/",
    name: "pghero",
    component: () => import("@/admin/pages/maintenance/pghero.vue"),
    meta: {
      title: "admin.maintenance.pghero",
      icon: "fa-duotone fa-database",
      needsAuthentication: true,
      access: ["pghero"],
    },
  },
  {
    path: "/tasks/",
    name: "tasks",
    component: () => import("@/admin/pages/maintenance/tasks.vue"),
    meta: {
      title: "admin.maintenance.tasks",
      icon: "fa-duotone fa-clipboard-list-check",
      needsAuthentication: true,
      access: ["maintenance"],
    },
  },
  {
    path: "/rsi-api-status/",
    name: "rsi-api-status",
    component: () => import("@/admin/pages/maintenance/rsi-api-status.vue"),
    meta: {
      title: "admin.maintenance.rsiApiStatus",
      icon: "fa-duotone fa-chart-line",
      needsAuthentication: true,
      access: ["rsi-api-status"],
    },
  },
];
